export const getInventoryVariantList = state => {
    return state.list
}

export const getInventoryVariantDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/inventoryVariant/getters.js